import { useEffect, useState } from 'react';
import { api } from '../../api.js';
import { Spinner, ErrorNote, fmtDay } from '../../components.jsx';

export default function OpportunitiesWidget() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/api/widgets/opportunities').then(setData).catch((e) => setError(e.message));
  }, []);

  return (
    <div className="card p-4">
      <div className="mb-3 flex items-center justify-between gap-2">
        {data ? (
          <a href={data.listUrl} target="_blank" rel="noreferrer" className="min-w-0 truncate text-sm font-bold uppercase tracking-wide text-steel hover:underline">
            Open opportunities
          </a>
        ) : (
          <h2 className="min-w-0 truncate text-sm font-bold uppercase tracking-wide text-steel">Open opportunities</h2>
        )}
        {data && <span className="badge shrink-0 bg-amber/30 text-charcoal dark:text-amber">{data.stageLabel}</span>}
      </div>
      {error && <ErrorNote>Couldn't reach EspoCRM ({error})</ErrorNote>}
      {!data && !error && <Spinner label="Loading pipeline…" />}
      {data && data.opportunities.length === 0 && <p className="text-sm text-steel">Nothing in this stage right now.</p>}
      {data && data.opportunities.length > 0 && (
        <ul className="divide-y divide-steel/10">
          {data.opportunities.map((o) => (
            <li key={o.id}>
              <a
                href={o.url}
                target="_blank"
                rel="noreferrer"
                className="-mx-1 flex items-center justify-between gap-3 rounded-md px-1 py-2 text-sm transition hover:bg-steel/10"
              >
                <div className="min-w-0">
                  <div className="truncate font-medium">{o.name}</div>
                  <div className="truncate text-xs text-steel">{o.account || '—'} · {o.assignedTo || 'Unassigned'}</div>
                </div>
                <div className="shrink-0 text-xs text-steel">{fmtDay(o.closeDate)}</div>
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
